export const config = [
  {
    texts: {
      header: "CS_SEARCH_RESULTS",
      actionButtonLabel: "WS_VIEW_DETAILS_AND_PAY",
    },
    labels: [
      {
        label: "WS_COMMON_TABLE_COL_AMT_DUE_LABEL",
        key: "AmountDue",
        noteStyle: {
          fontSize: "24px",
          fontWeight: "bold",
        },
        notePrefix: "₹ ",
      },
      {
        label: "WS_MYCONNECTIONS_CONSUMER_NO",
        key: "ConsumerNumber",
      },
      {
        label: "WS_CONSUMER_NAME_LABEL",
        key: "ConsumerName",
      },
      {
        label: "WS_MYCONNECTION_ADDRESS",
        key: "Address",
      },
      {
        label: "WS_VIEW_BILL_DUE_DATE_LABEL",
        key: "DueDate",
      },
    ],
  },
];
